"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundRateErrorMessage = exports.InboundRateErrorCode = void 0;
var InboundRateErrorCode;
(function (InboundRateErrorCode) {
    InboundRateErrorCode["TRANSACTION_SUCCESSFUL_EXISTS"] = "TRANSACTION_SUCCESSFUL_EXISTS";
    InboundRateErrorCode["SHIPPING_OPTION_BAD"] = "SHIPPING_OPTION_BAD";
    InboundRateErrorCode["QUOTE_NONEXISTANT"] = "QUOTE_NONEXISTANT";
    InboundRateErrorCode["QUOTE_UNUSEABLE"] = "QUOTE_UNUSEABLE";
    InboundRateErrorCode["QUOTE_EXPIRED"] = "QUOTE_EXPIRED";
    InboundRateErrorCode["LTL_SETUP_MISSING_INFO"] = "LTL_SETUP_MISSING_INFO";
    InboundRateErrorCode["LTL_SETUP_TOO_EXPENSIVE"] = "LTL_SETUP_TOO_EXPENSIVE";
    InboundRateErrorCode["LTL_GTZ_INVALID_PHONE"] = "LTL_GTZ_INVALID_PHONE";
    InboundRateErrorCode["LTL_RACE_CONDITION"] = "LTL_RACE_CONDITION";
    InboundRateErrorCode["LTL_GTZ_FAIL_SILENT"] = "LTL_GTZ_FAIL_SILENT";
    InboundRateErrorCode["LTL_GTZ_FAIL_QUOTE"] = "LTL_GTZ_FAIL_QUOTE";
    InboundRateErrorCode["LTL_GTZ_ZERO_QUOTE"] = "LTL_GTZ_ZERO_QUOTE";
    InboundRateErrorCode["LTL_GTZ_FAIL_BUY"] = "LTL_GTZ_FAIL_BUY";
    InboundRateErrorCode["SPD_PACKAGES_MISSING"] = "SPD_PACKAGES_MISSING";
    InboundRateErrorCode["SPD_RACE_CONDITION"] = "SPD_RACE_CONDITION";
    InboundRateErrorCode["SPD_SHIPPO_PACKAGE_UNRECOGNIZED"] = "SPD_SHIPPO_PACKAGE_UNRECOGNIZED";
    InboundRateErrorCode["SPD_SHIPPO_QUOTE_INCOMPLETE"] = "SPD_SHIPPO_QUOTE_INCOMPLETE";
    InboundRateErrorCode["SPD_SHIPPO_QUOTE_ADDRESS"] = "SPD_SHIPPO_QUOTE_ADDRESS";
    InboundRateErrorCode["SPD_SHIPPO_QUOTE_MISC"] = "SPD_SHIPPO_QUOTE_MISC";
    InboundRateErrorCode["SPD_SHIPPO_BUY_MISC"] = "SPD_SHIPPO_BUY_MISC";
    InboundRateErrorCode["SPD_SHIPPO_BUY_INCOMPLETE"] = "SPD_SHIPPO_BUY_INCOMPLETE";
})(InboundRateErrorCode = exports.InboundRateErrorCode || (exports.InboundRateErrorCode = {}));
exports.InboundRateErrorMessage = {
    TRANSACTION_SUCCESSFUL_EXISTS: "rates have already been bought for this shipment",
    SHIPPING_OPTION_BAD: "shipping option isnt one we can quotes or buy for",
    QUOTE_NONEXISTANT: "quote id does not exist",
    QUOTE_UNUSEABLE: "quote is not useable",
    QUOTE_EXPIRED: "quote has expired",
    LTL_GTZ_FAIL_SILENT: "transportation service silent fail: no results, no errors why",
    LTL_SETUP_MISSING_INFO: "missing either active pallets or an active pickup for shipment",
    LTL_SETUP_TOO_EXPENSIVE: "unit price per pound is too expensive to ship",
    LTL_GTZ_INVALID_PHONE: "invalid phone number provided",
    LTL_RACE_CONDITION: "race condition detected for LTL",
    LTL_GTZ_FAIL_QUOTE: "couldnt get rates from gtz after 3 tries",
    LTL_GTZ_ZERO_QUOTE: "got 0 quotes, pickup date might be a holiday or weekend or try again later",
    LTL_GTZ_FAIL_BUY: "GTZ failed to buy quotes",
    SPD_PACKAGES_MISSING: "shipment has no active packages",
    SPD_RACE_CONDITION: "race condition detected for SPD",
    SPD_SHIPPO_PACKAGE_UNRECOGNIZED: "shippo has no information for a package when getting a quote",
    SPD_SHIPPO_QUOTE_INCOMPLETE: "the amount of packages shippo recognizes does not match the amount of inbound packages",
    SPD_SHIPPO_QUOTE_ADDRESS: "invalid origin address for packags",
    SPD_SHIPPO_QUOTE_MISC: "unknown error getting quotes from shippo for packages in shipment",
    SPD_SHIPPO_BUY_MISC: "buying shipping rates failed",
    SPD_SHIPPO_BUY_INCOMPLETE: "useable transactions does not match packages amount",
};
//# sourceMappingURL=RaterError.js.map